import * as React from 'react'
import { CloseOutline } from '@easy-eva-icons/react'
import { Icon, Tag } from 'src/design-system'
import styles from './SkillsSidebar.module.scss'
import { Skill } from './types'
import { twoDecimals } from './utils'

// Map<id, desired skill level>
type SkillRequirements = Map<number, number>

type SkillsSidebarProps = {
  currentRequirements: SkillRequirements
  skills: Skill[]
  onClose: (skills: SkillRequirements) => void
}

export const SkillsSidebar: React.VFC<SkillsSidebarProps> = ({
  currentRequirements,
  skills,
  onClose,
}) => {
  const [changedSkills, setChangedSkills] = React.useState<Map<number, number>>(
    new Map(currentRequirements),
  )
  const [query, setQuery] = React.useState('')

  const filteredSkills = skills.filter(({ name }) =>
    name.toLowerCase().includes(query.toLowerCase()),
  )

  return (
    <div>
      <div className={styles.overlay} onClick={() => onClose(changedSkills)} />
      <aside className={styles.sidebar}>
        <div className={styles.header}>
          <h3>Skill requirements</h3>
          <button onClick={() => onClose(changedSkills)}>
            <Icon size="sm" style={{ color: 'currentcolor' }}>
              <CloseOutline />
            </Icon>
          </button>
        </div>
        <input
          className={styles.search}
          onChange={(e) => setQuery(e.target.value)}
          value={query}
        />
        <ul>
          {filteredSkills.map(({ id, name, maxLevel }) => (
            <li key={id}>
              <p>
                {name}{' '}
                {changedSkills.has(id) && <Tag variant="success">Adjusted</Tag>}
              </p>
              <NumberControl
                max={maxLevel}
                onChange={(number) =>
                  setChangedSkills((map) => {
                    const newMap = new Map(map)
                    newMap.set(id, number)
                    return newMap
                  })
                }
                value={changedSkills.get(id) ?? 3}
              />
            </li>
          ))}
        </ul>
      </aside>
    </div>
  )
}

type NumberControlProps = {
  max: number
  onChange: (number: number) => void
  value: number
}

export const NumberControl: React.VFC<NumberControlProps> = ({
  max,
  onChange,
  value,
}) => (
  <input
    className={styles.numberControl}
    max={max}
    min={1}
    onChange={(e) => onChange(Number(e.target.value))}
    step={0.5}
    type="number"
    value={twoDecimals(value)}
  />
)
